module.exports = __webpack_public_path__ + "img/icon_login_method.db947dc4.png";